import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';
// import S3Uploader from '../../common/uploader/S3Uploader';
// import Dropzone from 'react-dropzone';
// import UploadProgress from '../../common/uploader/UploadProgress';
import { t } from '../../../utils/translate';
import QuestionWrapper from '../response/QuestionWrapper';
import Icon from '../../common/Icon.react';
import classNames from 'classnames';

const createUrl = '/multi_attachments';
const progressUrl = '/multi_attachments/progress';
const signS3Url = '/multi_attachments/sign_s3';

export class MediaUploadQuestionContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      isUploading: false
    };
  }

  // File upload handlers - commented out for now
  /*
  handleDrop = (acceptedFiles) => {
    this.setState(prevState => ({
      files: [...prevState.files, ...acceptedFiles],
      isUploading: true
    }));
  }

  handleUploadComplete = () => {
    this.setState({ isUploading: false });
  }

  handleFileRemove = (fileToRemove) => {
    this.setState(prevState => ({
      files: prevState.files.filter(file => file !== fileToRemove)
    }));
  }
  */

  componentDidMount() {
    console.log('MediaUploadQuestion mounted with maxFiles:', this.props.maxFiles);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.maxFiles !== this.props.maxFiles) {
      console.log('MediaUploadQuestion maxFiles updated:', this.props.maxFiles);
    }
  }

  render() {
    const numFiles = Number(this.props.maxFiles) || 1;
    console.log('MediaUploadQuestion rendering with numFiles:', numFiles);
    
    return (
      <div className="media-upload">
        {/* Create array of length maxFiles and map over it */}
        {[...Array(numFiles)].map((_, index) => (
          <div key={index} className="mb2">
            <button 
              type="button"
              className={classNames('media-upload__button')}
              onClick={() => console.log(`Upload button ${index + 1} clicked`)}
            >
              <Icon icon="upload" className="media-upload__icon" />
              {t('Upload an image')} {numFiles > 1 ? `(${index + 1}/${numFiles})` : ''}
            </button>
          </div>
        ))}
      </div>
    );
  }
}

MediaUploadQuestionContent.propTypes = {
  attachmentParams: PropTypes.object,
  maxFiles: PropTypes.number,
  mimeTypes: PropTypes.string,
  questionId: PropTypes.string.isRequired,
  tempMultiAttachmentKeyFieldName: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];

  return {
    attachments: state.attachmentsTmap
      ? state.attachmentsTmap[question.name]
      : [],
    isValid: question.isValid,
    ...state.attachmentConfig,
    attachmentParams: {
      attachment: {
        surveyQuestionId: ownProps.questionId,
        tempMultiAttachmentKey: question.tempMultiAttachmentKey,
      },
      attachableId: question.tempMultiAttachmentKey,
      attachableType: 'Survey::Response',
      tokenId: state.token.id,
    },
    tempMultiAttachmentKeyFieldName: `questions[images][${question.name}][]`,
  };
};

const ConnectedMediaUploadContent = connect(mapStateToProps)(MediaUploadQuestionContent);

const MediaUploadQuestion = props => {
  const { id, required, maxFiles } = props;
  console.log('MediaUploadQuestion wrapper received maxFiles:', maxFiles);
  return (
    <QuestionWrapper {...props}>
      <ConnectedMediaUploadContent
        name={`questions[${props.name}]`}
        questionId={id}
        required={required}
        maxFiles={props.number_of_files}
        mimeTypes={props.mimeTypes}
      />
    </QuestionWrapper>
  );
};

MediaUploadQuestion.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
  maxFiles: PropTypes.number,
  mimeTypes: PropTypes.string
};

MediaUploadQuestion.defaultProps = {
  maxFiles: 1,
  mimeTypes: 'image/jpeg, image/png, image/gif, image/webp'
};

export { mapStateToProps };
export default MediaUploadQuestion;
